/**
 * Type of NBBO information.
 * tag: 2831
 * @readonly
 * @enum {number} (int)
 */
export enum NBBOEntryType {
  Bid = 0,
  Offer = 1,
  /** Mid-price */
  MidPrice = 2,
}
